import React from 'react'
import { Card } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { TotalSummary } from './TotalSummary'
import { calculateDocumentTotals } from '../../utils/calculations'
import { useCompanyStore } from '../../store/company/companyStore'

export const DocumentFooter: React.FC = () => {
  const lineItems = useFFEStore((state) => state.document.lineItems)
  const groups = useFFEStore((state) => state.document.groups)
  const documentSettings = useFFEStore((state) => state.document.settings)
  const materials = useFFEStore((state) => state.document.materials)
  const { settings } = useCompanyStore((state) => state.company)
  const totals = calculateDocumentTotals(
    lineItems,
    groups,
    documentSettings,
    settings,
    materials
  )

  return (
    <Card className="mt-8">
      <div className="flex justify-end">
        <div className="w-[400px]">
          <TotalSummary totals={totals} />
        </div>
      </div>
    </Card>
  )
}
